export default __webpack_public_path__ + "static/media/circle_dark.21c46a05.svg";